
/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle, styled } from '@mui/material';

// import { JsonServiceClient } from '@servicestack/client';
import { FC, useMemo } from 'react';

/*
 * ----------------------------------------------------------------------------------
 * Imports - Internal
 * ----------------------------------------------------------------------------------
 */
import { IPatient } from '@ngt/opms';
import { Patient, PatientStateType } from '../../../api/dtos';
import { PatientSummaryAllocationInfoSeverity } from './PatientSummaryAllocationInformation';


const StyledAlert = styled(Alert)(({ theme }) => ({
    width: '100%', 
    padding: '1rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    
    '& > *': {
        '&:last-of-type': {
            width: '100%'
        },
    }
}));


export interface IPatientStatusInformationProps {
    patient: IPatient | null | undefined;
}

const PatientStatusInformation: FC<IPatientStatusInformationProps> = ({
    patient
}) => {

    const showStatusInfo = useMemo(() => {
        return patient?.patientStateId === PatientStateType.Ineligible
    }, [patient?.patientStateId])

    return (
        <>
            {
                showStatusInfo && <StyledAlert 
                    severity={PatientSummaryAllocationInfoSeverity.Info} 
                    icon={<FontAwesomeIcon icon={faInfoCircle} fixedWidth />}
                >
                    {
                        patient?.patientStateId === PatientStateType.Ineligible && <>
                            <AlertTitle>
                                Marked as Ineligible
                            </AlertTitle>
                            {(patient as Patient).ineligibleReason} &nbsp;
                        </>
                    }
                </StyledAlert>  
            }  
        </>
    )
}

export default PatientStatusInformation;